module.exports = __webpack_public_path__ + "img/arrow-right.c815b06d-237cac87.ad4017b1.svg";